import React from 'react';

var convertSizeForIcon = function convertSizeForIcon(size) {
  var iconSize = "sm";

  switch (size) {
    case "sm":
      iconSize = "xs";
      break;

    case "md":
      iconSize = "xs";
      break;

    case "lg":
      iconSize = "sm";
      break;
  }

  return iconSize;
};

var useChip = function useChip(_ref) {
  var _ref$isChecked = _ref.isChecked,
      isChecked = _ref$isChecked === void 0 ? false : _ref$isChecked,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isError = _ref.isError,
      isError = _ref$isError === void 0 ? false : _ref$isError,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      _ref$kind = _ref.kind,
      kind = _ref$kind === void 0 ? "solid" : _ref$kind,
      media = _ref.media,
      onDismiss = _ref.onDismiss,
      size = _ref.size;
  var iconSize = convertSizeForIcon(size);
  var MediaComponent;

  if (!!media &&
  /*#__PURE__*/
  React.isValidElement(media)) {
    var mediaSize = size === "sm" ? "xxs" : "xs";
    MediaComponent =
    /*#__PURE__*/
    React.cloneElement(media, {
      size: mediaSize
    });
  }

  var handleDismiss = function handleDismiss(event) {
    event.stopPropagation();
    onDismiss == null ? void 0 : onDismiss(event);
  };

  var chipKind = kind;

  if (isChecked) {
    chipKind = kind === "solid" ? "outline" : "solid";
  }

  var showError = !!isError;
  var showDismiss = !isDisabled && !!onDismiss;
  var showProgress = !isError && !!isLoading;
  return {
    iconSize: iconSize,
    MediaComponent: MediaComponent,
    handleDismiss: handleDismiss,
    chipKind: chipKind,
    showError: showError,
    showDismiss: showDismiss,
    showProgress: showProgress
  };
};

export { useChip as default };